import './blog_single.scss';

console.log('blog_single')